import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';

import NavigationBar from '../core/widgets/ui/NavigationBar';

import { useRecoilState } from 'recoil';
import { orgAtom, outletAtom, subAtom } from '../core/config/atoms';

import socket from 'core/config/socket';

import Lottie from 'lottie-react';
import { useReactToPrint } from "react-to-print";

import LayoutPos from 'layouts/LayoutPos';
import LayoutReception from 'layouts/LayoutReception';
import LayoutOrder from 'layouts/LayoutOrder';
import LayoutKDS from 'layouts/LayoutKDS';
import LayoutStaff from 'layouts/LayoutStaff';
import LayoutSetting from 'layouts/LayoutSetting';
import LayoutReports from 'layouts/LayoutReports';

import { PrintKOT } from 'core/widgets/ui/print/PrintKOT';
import { PrintBill } from 'core/widgets/ui/print/PrintBill';
import { PrintBooking } from 'core/widgets/ui/print/PrintBooking';
import { PrintHostelBill } from 'core/widgets/ui/print/PrintHostelBill';

import ServiceOutlet from 'services/serviceOutlet';

import animPage from '../assets/anim/anim-pageload.json';
import LayoutInventory from 'layouts/LayoutInventory';

export default function PageHome() {

    const contentKOTRef = useRef(null);
    const contentBillRef = useRef(null);
    const contentBookingRef = useRef(null);
    const contentHostelBookRef = useRef(null);

    const { page } = useParams();

    const [outlet] = useRecoilState(outletAtom);
    const [org] = useRecoilState(orgAtom);
    const [sub] = useRecoilState(subAtom);

    const [printPayload, setPrintPayload] = useState({});
    const [taxSetting, setTaxSetting] = useState({});

    const [loading, setLoading] = useState(true);
    const [isPrintKOT, setIsPrintKOT] = useState(false);
    const [isPrintBill, setIsPrintBill] = useState(false);
    const [isPrintBooking, setIsPrintBooking] = useState(false);
    const [isPrintHostelBook, setIsPrintHostelBook] = useState(false);

    const outletService = new ServiceOutlet();

    const sendToPrint = (payload, type) => {
        setPrintPayload(payload);
        switch (type) {
            case "printKOT":
                setIsPrintKOT(true);
                break;
            case "printBill":
                setIsPrintBill(true);
                break;
            case "printBooking":
                setIsPrintBooking(true);
                break;
            case "printHostelBook":
                setIsPrintHostelBook(true);
                break;
            default:
                console.log("Printer type not found!");
                break;
        }
    }

    const handleMessage = (message) => {
        if (outlet.outletid.outletid === message.outletid) {
            switch (message.type) {
                case "printKOT":
                    sendToPrint(message.payload, message.type);
                    break;
                case "printBill":
                    sendToPrint(message.payload, message.type);
                    break;
                case "printBooking":
                    sendToPrint(message.payload, message.type);
                    break;
                case "printHostelBook":
                    sendToPrint(message.payload, message.type);
                    break;
                default:
                    console.log("Message type not found!");
                    break;
            }
        }
    };

    const handleAfterPrint = React.useCallback(() => {
        setIsPrintKOT(false);
        setIsPrintBill(false);
        setIsPrintBooking(false);
        setIsPrintHostelBook(false);
    }, []);

    const handleBeforePrint = React.useCallback(() => {
        return Promise.resolve();
    }, []);

    const printFnKot = useReactToPrint({
        contentRef: contentKOTRef,
        documentTitle: "KOT",
        onAfterPrint: handleAfterPrint,
        onBeforePrint: handleBeforePrint,
    });

    const printFnBill = useReactToPrint({
        contentRef: contentBillRef,
        documentTitle: "Bill",
        onAfterPrint: handleAfterPrint,
        onBeforePrint: handleBeforePrint,
    });

    const printFnBooking = useReactToPrint({
        contentRef: contentBookingRef,
        documentTitle: "Booking",
        onAfterPrint: handleAfterPrint,
        onBeforePrint: handleBeforePrint,
    });

    const printFnHostelBook = useReactToPrint({
        contentRef: contentHostelBookRef,
        documentTitle: "Hostel Book",
        onAfterPrint: handleAfterPrint,
        onBeforePrint: handleBeforePrint,
    });

    useEffect(() => {
        if (isPrintKOT) {
            printFnKot();
        }
    }, [isPrintKOT]);

    useEffect(() => {
        if (isPrintBill) {
            printFnBill();
        }
    }, [isPrintBill]);

    useEffect(() => {
        if (isPrintHostelBook) {
            printFnHostelBook();
        }
    }, [isPrintHostelBook]);

    useEffect(() => {
        if (isPrintBooking) {
            printFnBooking();
        }
    }, [isPrintBooking]);

    useEffect(() => {
        if (Object.keys(outlet).length !== 0) {
            setLoading(false);
        }
    }, [outlet, setLoading]);

    useEffect(() => {
        if (Object.keys(outlet).length !== 0) {
            socket.on(org, handleMessage);
        }

        return () => {
            if (Object.keys(outlet).length !== 0) {
                socket.off(org, handleMessage);
            }
        };
    }, [outlet, org]);

    const loadData = () => {
        (async function () {
            if (sub.features.isTax) {
                var res = await outletService.getOutletById({ 'outletid': outlet.outletid.outletid });
                const taxSet = res.data.tax;
                setTaxSetting(taxSet);
            }
        })();
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <>
            <PrintKOT ref={contentKOTRef} isPrint={isPrintKOT} payload={printPayload} />
            <PrintBill ref={contentBillRef} isPrint={isPrintBill} payload={printPayload} />
            <PrintBooking ref={contentBookingRef} isPrint={isPrintBooking} payload={printPayload} taxSetting={taxSetting} />
            <PrintHostelBill ref={contentHostelBookRef} isPrint={isPrintHostelBook} payload={printPayload} />
            {
                loading && <div className='flex items-center justify-center w-full h-full'>
                    <Lottie animationData={animPage} className="w-40 h-40" loop={true} />
                </div>
            }
            {
                !loading && <div className='w-full h-screen overflow-hidden flex relative'>
                    <NavigationBar />
                    <div className='w-full h-screen overflow-hidden flex relative'>
                        {(() => {
                            switch (page) {
                                case 'pos':
                                    return (<LayoutPos />);
                                case 'reception':
                                    return (<LayoutReception />);
                                case 'kds':
                                    return (<LayoutKDS />);
                                case 'order':
                                case 'invoices':
                                case 'booking':
                                    return (<LayoutOrder />);
                                case 'inventory':
                                case 'invAdj':
                                case 'invAdjAdd':
                                case 'invItems':
                                case 'itemAdd':
                                case 'bom':
                                case 'bomAdd':
                                    return (<LayoutInventory />);
                                case 'staff':
                                    return (<LayoutStaff />);
                                case 'reports':
                                case 'bookReports':
                                case 'reportItem':
                                case 'reportOrder':
                                case 'reportInvoice':
                                case 'reportBooking':
                                case 'reportHBook':
                                case 'reportAttend':
                                case 'reportCRM':
                                case 'reportTrn':
                                case 'reportGST':
                                    return (<LayoutReports />);
                                case 'setting':
                                case 'company':
                                case 'subscription':
                                case 'print':
                                case 'tax':
                                case 'table':
                                case 'room':
                                case 'roomType':
                                case 'menu':
                                case 'hostel':
                                case 'rental':
                                    return (<LayoutSetting />);
                                default:
                                    return (
                                        <div className="w-full h-full text-5xl flex items-center justify-center" style={{ height: "80vh" }}>
                                            No Data Found
                                        </div>
                                    );
                            }
                        })()}
                    </div>
                </div>
            }
        </>
    )
}
